export const environment = {
  production: false,
  BaseUrl: 'https://dev.apis.srv1954566.hstgr.cloud/api',
  /**
   * El servicio de IDENTIDAD, que contesta `GET /sesion/actual` y
   * `POST /sesion/elegir-acceso`. Lo consume `proveerSesion` en `app.config.ts`.
   */
  identidadUrl: 'https://dev.srv1954566.hstgr.cloud/api/v1',
  // Login CENTRAL (el nombre `logoutUrl` es historico, de cuando era el SSO viejo).
  logoutUrl: 'https://dev.srv1954566.hstgr.cloud/',
  socketUrl: 'http://localhost:3000',
};
